"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "userForm",
    attrs: {
      model: _vm.userForm,
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "validatePhone"
    }
  }, [_c("el-input", {
    attrs: {
      type: "phone",
      autocomplete: "off",
      clearable: true,
      placeholder: "手机号",
      maxlength: "11"
    },
    model: {
      value: _vm.userForm.validatePhone,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "validatePhone", $$v);
      },
      expression: "userForm.validatePhone"
    }
  }, [_c("img", {
    staticClass: "margin-left-5 width-21",
    attrs: {
      slot: "prefix",
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/lQLPKIGh3DfINEEZFLBNn4hZwTu9ewmspXF3gJsB_20_25.png"
    },
    slot: "prefix"
  })])], 1), _c("el-form-item", {
    attrs: {
      prop: "validatePass"
    }
  }, [_c("el-input", {
    attrs: {
      type: "password",
      autocomplete: "off",
      clearable: true,
      placeholder: "密码"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.toLogin("userForm");
      }
    },
    model: {
      value: _vm.userForm.validatePass,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "validatePass", $$v);
      },
      expression: "userForm.validatePass"
    }
  }, [_c("img", {
    staticClass: "margin-left-5 width-21",
    attrs: {
      slot: "prefix",
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/lQLPJyCzvz8mZEEbFbCBH4Eg4yv_RgmspXF3gJsA_21_27.png"
    },
    slot: "prefix"
  })])], 1), _c("div", {
    staticClass: "form-options"
  }, [_c("el-checkbox", {
    model: {
      value: _vm.rememberMe,
      callback: function callback($$v) {
        _vm.rememberMe = $$v;
      },
      expression: "rememberMe"
    }
  }, [_vm._v("记住密码")]), _c("span", {
    staticClass: "forget-pass",
    on: {
      click: _vm.toForgetPassword
    }
  }, [_vm._v("忘记密码")])], 1), _c("div", {
    staticClass: "agreement-row text-left"
  }, [_c("el-checkbox", {
    model: {
      value: _vm.agreementChecked,
      callback: function callback($$v) {
        _vm.agreementChecked = $$v;
      },
      expression: "agreementChecked"
    }
  }, [_c("span", [_vm._v("我已阅读并同意")]), _c("el-link", {
    attrs: {
      type: "primary",
      underline: false
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        _vm.$root.innerVisible = true;
      }
    }
  }, [_vm._v("《用户协议》")]), _c("span", [_vm._v("、")]), _c("el-link", {
    attrs: {
      type: "primary",
      underline: false
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toPrivacy.apply(null, arguments);
      }
    }
  }, [_vm._v("《隐私政策》")]), _c("span", [_vm._v("和")]), _c("el-link", {
    attrs: {
      type: "primary",
      underline: false
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toShippingInstructions.apply(null, arguments);
      }
    }
  }, [_vm._v("《运输须知》")])], 1)], 1), _c("el-form-item", [_c("el-button", {
    staticClass: "login_btn",
    attrs: {
      type: "primary",
      disabled: _vm.submitDisabled || !_vm.agreementChecked
    },
    on: {
      click: function click($event) {
        return _vm.toLogin("userForm");
      }
    }
  }, [_vm._v(" 登录 ")])], 1), _c("el-dialog", {
    attrs: {
      title: _vm.agreementDialogTitle,
      visible: _vm.agreementDialogVisible,
      width: "70%",
      top: "5vh",
      center: "",
      "append-to-body": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.agreementDialogVisible = $event;
      }
    }
  }, [_vm.agreementDialogVisible ? _c("iframe", {
    staticClass: "agreement-document-frame",
    attrs: {
      src: _vm.agreementDialogUrl,
      title: _vm.agreementDialogTitle
    }
  }) : _vm._e()])], 1), _c("div", {
    staticClass: "app-download"
  }, [_vm._v("APP下载")])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;